// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2022-11-14 21:55:03 +0100 (Mon, 14 Nov 2022) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 130625 $
//  Purpose   : states package
// =============================================================================
export const parts = true

export {sagas} from './sagas'

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}

import * as selectors from './selectors'
export {selectors}

import {get} from 'ldash'

export const translateState = (i18n, statusType, statusValue) => {
  if (statusValue === undefined) {
    return ''
  } else if (statusValue === null) {
    return i18n[`__noentry_${statusType}`] || i18n['__noentry']
  }
  statusValue = String(statusValue)

  let k = `${statusType}_state_${statusValue}`
  let res = i18n[k]
  if (!res) {
    res = get(i18n, `${statusType}_state_${statusValue.replace(/ /g, '_')}`, statusValue)
  }
  return res
}

export {isStateDomainVisible} from './hooks'
